import { ValueVector } from "src/app/models/value-vector.model";

export function parseArrayFromString(input: string): string | ValueVector {
	try {
		const parsed = JSON.parse(input);
		if (Array.isArray(parsed)) {
			return parsed;
		}
	} catch {
		// Ignore error; fall through to return original string
	}
	return input;
}
